export default "__VITE_ASSET__Dhv3tIDq__"